import { newPermissions } from '@shared/newPermissions';

import { CouncilUnitsPage } from './components';
import { ROUTE_COUNCIL_UNITS } from './duck';

const routes = {
  [ROUTE_COUNCIL_UNITS]: {
    path: '/units',
    Component: CouncilUnitsPage,
    titleId: 'page.units',
    permission: newPermissions.VIEW_COUNCIL_UNITS_PAGE,
  },
};

export default routes;
